import { Box } from "@material-ui/core";
import { clone } from "ramda";
import { FC, useEffect, useState } from "react";

import { GenericObject } from "../../types/generic.types";
import StepperItem from "./StepperItem";

const StepperCancellationPolicies: FC<{ steps: GenericObject[] }> = ({ steps }) => {
  let sortedSteps = clone(steps);
  sortedSteps = sortedSteps.sort(function (a: any, b: any) {
    return Number(a.cancelTime) - Number(b.cancelTime);
  });

  const [hasZeroCancel, setHasZeroCancel] = useState(false);

  useEffect(() => {
    const x = steps.filter((step) => step.cancelTime && Number(step.cancelTime) === 0);
    setHasZeroCancel(!!x.length);
  }, [steps]);

  return (
    <Box display="flex" alignItems="center">
      {!hasZeroCancel && <StepperItem step={{ cancelTime: 0, charge: 0 }} />}
      {sortedSteps.map((step, index) => {
        return <StepperItem step={{ cancelTime: step.cancelTime, charge: step.charge }} key={index} />;
      })}
      <Box
        style={{
          position: "relative",
          zIndex: 2,
          backgroundColor: "#74BD76",
          fontSize: 24,
          color: "#fff",
          width: 35,
          height: 35,
          borderRadius: "50%",
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <span style={{ paddingBottom: 4 }}>&infin;</span>
      </Box>
    </Box>
  );
};

export default StepperCancellationPolicies;
